import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {
  sdoNs,
} from '@modules/constants-enumerate';

const sdo = {
  namespace: sdoNs.GROUP_FILTERS_MENU,
  mutations: {
    init() {
      return {
        loading: false,
        groupsAtLevel: {}
      };
    },
  },
  decorators: [
    (nextState) => { // $levelBelowTopOrg
      const state = storeInstance.getState();
      const sessionNextState = nextState[sdoNs.SESSION];
      const nextSubState = nextState[sdoNs.GROUP_FILTERS_MENU];
      if (
        typeof nextSubState.$levelBelowAdminOrg === 'undefined' ||
        sessionNextState.group_info !== state[sdoNs.SESSION].groupInfo
      ) {
        let $levelBelowAdminOrg = 1;
        if (sessionNextState?.group_info?.level) {
          $levelBelowAdminOrg = sessionNextState?.group_info?.level + 1;
        }
        nextState = deepAssign(nextState, sdoNs.GROUP_FILTERS_MENU, {
          $levelBelowAdminOrg,
        });
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);

